const backend = [
  {
    technology: 'Java',
  },
  {
    technology: 'NodeJS',
  },
  {
    technology: 'Spring',
  },
  {
    technology: 'Hibernate',
  },
  {
    technology: 'Python',
  },
  {
    technology: 'NestJS',
  },
];

export default backend;
